var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InfoModal',{attrs:{"title":"Tack för din komplettering","mobile-full-width":"","abort-label":"Stäng"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"body"},[_c('p',[_vm._v(" Vi har tagit emot din komplettering. Våra handläggare kommer att se över dina uppgifter och återkoppla så snart som möjligt. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }